import { createFileRoute } from '@tanstack/react-router';
import { SupplierProfilePage } from '@/features/purchasing/SupplierProfile';
export const Route = createFileRoute(
  '/_dashboard/dashboard/purchasing/suppliers/$supplierId_/edit',
)({
  component: Page,
});
function Page() {
  const { supplierId } = Route.useParams();
  return <SupplierProfilePage key={supplierId} supplierId={supplierId} />;
}
